module.exports = __webpack_public_path__ + "img/american-express.1932bfd.svg";